declare const ENV_API_ENDPOINT: string | undefined;
declare const ENV_REPORT_SERVER_ENDPOINT: string | undefined;

export const API_ENDPOINT = ENV_API_ENDPOINT || "http://localhost:9000";

export const REPORT_SERVER_ENDPOINT =
  ENV_REPORT_SERVER_ENDPOINT || "http://localhost:9001";
